import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {changeField, initialize} from '../../modules/chat/feedback';
import validateInput from '../../utils/validateInput';
import styles from './styles/feedback-modal.module.css';

import Button from '../common-women/Button';
import {ReactComponent as CheckboxActive} from '../../assets/chat-feedback/checkbox-active.svg';
import {ReactComponent as Checkbox} from '../../assets/chat-feedback/checkbox.svg';
import {ReactComponent as Close} from '../../assets/chat-feedback/close.svg';

const optionMap = [
    '의도와 다른 답변',
    '사실이 아닌 답변',
    '부족하거나 과한 답변',
    '자연스럽지 않은 문장',
    '답이 나오지 않음'
];

export default function FeedbackModal({ optionList, inputText, answerId, submitFeedback, toggleFeedbackModal }) {
    const dispatch = useDispatch();

    const toggleOption = (selectedOption) => {
        const isSelected = optionList.some(option => option === selectedOption);

        dispatch(changeField({
            name: 'optionList',
            value: isSelected 
                ? optionList.filter(option => option !== selectedOption)
                : [...optionList, selectedOption]
        }));
    };

    const changeInputText = (e) => {
        const { name, value } = e.target;

        dispatch(changeField({
            name,
            value
        }));
    };

    const handleSubmitFeedback = () => {
        if (!validateInput(inputText.trim())) {
            alert('입력 값에 허용되지 않는 특수문자 또는 위험한 코드가 포함되어 있습니다.');
            return;
        }

        submitFeedback(answerId, 'NEGATIVE');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmitFeedback();
        }
    };

    const validateBtn = () => {
        return inputText.trim().length > 0;
    };

    const getBtnStyle = (isActive) => {
        return {
            backgroundColor: isActive ? '#825DFC' : '#DDDEE2',
            disabled: !isActive
        };
    };

    useEffect(() => {
        dispatch(initialize());
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.containerTitle}>
                <div className={styles.boxTitle}>
                    <p>답변이 마음에 들지 않은 이유를 알려주세요</p>
                    <div className={styles.description}>다중선택 가능</div>
                </div>
                <Close style={{cursor: 'pointer'}} onClick={toggleFeedbackModal} />
            </div>
            <ul className={styles.containerContent}>
                {optionMap.map(option => {
                    const isSelected = optionList.some(item => item === option);
                    return (
                        <li
                            key={option}
                            className={styles.boxCheckbox}
                            onClick={() => toggleOption(option)}
                        >
                            {isSelected ? <CheckboxActive /> : <Checkbox />}
                            <p className={styles.name}>{option}</p>
                        </li>
                    );
                })}
            </ul>
            <div className={styles.containerTextarea}>
                <textarea
                    placeholder='(필수) 자유롭게 작성해 주세요.'
                    name='inputText'
                    value={inputText}
                    onChange={changeInputText}
                    onKeyDown={handleKeyDown}
                />
                <Button
                    text='보내기'
                    width='102px'
                    height='38px'
                    padding='8px 28px'
                    backgroundColor='#DDDEE2'
                    borderRadius='5px'
                    fontSize='16px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={validateBtn() ? () => handleSubmitFeedback(optionList, inputText) : null}
                    {...getBtnStyle(validateBtn())}
                />
            </div>
        </div>
    );
}
